import Hero from "@/components/home/Hero";
import FeaturedShowcase from "@/components/home/FeaturedShowcase";
import Manifesto from "@/components/home/Manifesto";
import Testimonials from "@/components/home/Testimonials";
import PricingPreview from "@/components/home/PricingPreview";
import PackageDetails from "@/components/home/PackageDetails";
import InstantQuote from "@/components/home/InstantQuote";
import VideoShowcase from "@/components/home/VideoShowcase";
import EmailCapture from "@/components/home/EmailCapture";
import BrandMarquee from "@/components/home/BrandMarquee";
import FinalCTA from "@/components/home/FinalCTA";
import Seo from "@/components/common/Seo";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo
        title="Mobile Car Detailing in Ottawa | Reverence Autos"
        description="Ottawa's largest mobile car detailing crew comes to you. Book in 60 seconds. Interior, full detail, express & ceramic coating across Orleans, Kanata, Barrhaven, Nepean, Stittsville, downtown Ottawa & Gatineau."
        path="/"
      />
      <Hero />
      <FeaturedShowcase />
      <Manifesto />
      <InstantQuote />
      <PricingPreview />
      <PackageDetails />
      <Testimonials />
      <VideoShowcase />
      <EmailCapture />
      <BrandMarquee />
      <FinalCTA />
    </div>
  );
}
